import React, { createContext, useContext, useState, useEffect } from 'react';

const EnvironmentContext = createContext();

export const useEnvironment = () => {
  const context = useContext(EnvironmentContext);
  if (!context) {
    throw new Error('useEnvironment must be used within an EnvironmentProvider');
  }
  return context;
};

export const EnvironmentProvider = ({ children }) => {
  const [environment, setEnvironment] = useState(() => {
    // Load from localStorage or default to production
    return localStorage.getItem('selectedEnvironment') || 'production';
  });

  const [apiBaseURL, setApiBaseURL] = useState(() => {
    const env = localStorage.getItem('selectedEnvironment') || 'production';
    return env === 'development' ? 'https://analytics.paradisetycoon.com/api-dev' : 'https://analytics.paradisetycoon.com/api';
  });

  const switchEnvironment = (newEnvironment) => {
    if (newEnvironment !== 'production' && newEnvironment !== 'development') {
      console.error('Invalid environment:', newEnvironment);
      return;
    }

    setEnvironment(newEnvironment);
    localStorage.setItem('selectedEnvironment', newEnvironment);
    
    // Update API base URL
    const newBaseURL = newEnvironment === 'development' 
      ? 'https://analytics.paradisetycoon.com/api-dev' 
      : 'https://analytics.paradisetycoon.com/api';
    setApiBaseURL(newBaseURL);

    // Reload the page to re-establish connections with the new environment
    window.location.reload();
  };

  const value = {
    environment,
    apiBaseURL,
    switchEnvironment,
    isDevelopment: environment === 'development',
    isProduction: environment === 'production'
  };

  return (
    <EnvironmentContext.Provider value={value}>
      {children}
    </EnvironmentContext.Provider>
  );
};

